import { initalState as modalState, mutations as modalMutations } from './modal.store';
import { state as contentState, mutations as contentMutations } from './content.store';

export default {
  state: {
    ...modalState,
    ...contentState,
  },
  mutations: {
    ...modalMutations,
    ...contentMutations,
  },
};
